import type { AiTutorUIMessage } from '~ai-tutor/lib/chatflow/types';

const STORAGE_KEY_MESSAGES = 'chat.messages';

const getStorageItem = (key: string): string | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (globalThis.window === undefined) return undefined;
  try {
    return localStorage.getItem(key) ?? undefined;
  } catch {
    return undefined;
  }
};

const setStorageItem = (key: string, value: string): void => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (globalThis.window === undefined) return;
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error(`Failed to write to localStorage (${key}):`, error);
  }
};

const removeStorageItem = (key: string): void => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (globalThis.window === undefined) return;
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Failed to remove from localStorage (${key}):`, error);
  }
};

const setMessages = (newMessages: AiTutorUIMessage[]) => {
  if (newMessages.length > 0) {
    setStorageItem(STORAGE_KEY_MESSAGES, JSON.stringify(newMessages));
  } else {
    removeStorageItem(STORAGE_KEY_MESSAGES);
  }
};

const getMessages = () => {
  const raw = getStorageItem(STORAGE_KEY_MESSAGES);

  if (raw) {
    try {
      const parsed = JSON.parse(raw) as unknown;
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed as AiTutorUIMessage[];
      }
    } catch (error) {
      console.error('Failed to parse chat from localStorage:', error);
      return [];
    }
  }
  return [];
};

const clearStorage = () => {
  removeStorageItem(STORAGE_KEY_MESSAGES);
};

export const useChatPersistence = () => {
  return {
    clearStorage,
    getMessages,
    setMessages,
  };
};
